import {
  AimAttachment,
  AimIdAttachmentPostParams,
  OpportunityAttachmentPostParams,
  TransactionTeamAttachmentPostParams
} from '../../models/AttachmentModels';
import { ENV } from '../../envUtils';

/**
 * Endpoint path builders for attachment operations, returning URL strings for the AIM API's attachment endpoints.
 *
 * All properties are functions that return a path string by combining ENV with a resource-specific path segment; they do not make HTTP requests themselves.
 */
export const attachmentEndpoints = {
  opportunityAttachments: (aimOpportunity: number) => `${ENV}/opportunity/${aimOpportunity}/attachments`,
  transactionTeamAttachments: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/attachments`,
  attachmentsByAimId: (aimId: string) => `${ENV}/${aimId}/attachments`,
  attachmentByPid: (pid: string) => `${ENV}/attachment/${pid}`,
  addAttachmentsByAimId: (payload: AimIdAttachmentPostParams) => `${ENV}/${payload.aimId}/attachments`,
  addOpportunityAttachments: (payload: OpportunityAttachmentPostParams) =>
    `${ENV}/opportunity/${payload.aimOpportunity}/attachments`,
  addTransactionTeamAttachments: (payload: TransactionTeamAttachmentPostParams) =>
    `${ENV}/transactionteam/${payload.aimTransactionTeam}/attachments`,
  deleteAttachment: (pid: string) => `${ENV}/attachment/${pid}`,
  bulkDeleteAttachments: (aimId: string) => `${ENV}/${aimId}/attachments`
};
